export const TextIcon = () => {
    return (
        <svg
            width={18}
            height={14}
            viewBox="0 0 18 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="stroke-black dark:stroke-white"
        >
            <path
                d="M1 3V1h12v2M7 13H5M7 1v12V1Zm0 12h2-2ZM11 8.5V7h6v1.5M14 13h1.5M14 7v6-6Zm0 6h-1.5H14Z"
                strokeWidth={1.5}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
